// src/lib/i18n/sections.ts
// Les sections du site et les langues où elles sont prêtes (13/10/2026, décision de David).
//
// Une section pas encore traduite est retirée des points d'entrée dans les autres langues :
// menu, pied de page, accueil, liens croisés, recherche. Son adresse directe reste servie,
// en français, avec un bandeau qui le dit (`BandeauSectionEnFrancais`) : une 404 casserait
// les liens partagés et ferait désindexer la page.
//
// Ouvrir une section dans une langue : ajouter la langue à sa ligne. Rien d'autre.

import type { Locale } from './config';

export type Section = 'brief' | 'rayonx' | 'veille' | 'loupe' | 'anatomies' | 'dossiers' | 'filRouges' | 'enquetes';

const LANGUES: Record<Section, readonly Locale[]> = {
  // Ouverts le 13/10/2026 : signaux de veille traduits (familles `signal` et `effet`).
  brief: ['fr', 'en', 'es'],
  rayonx: ['fr'],
  veille: ['fr', 'en', 'es'],
  loupe: ['fr'],
  anatomies: ['fr'],
  dossiers: ['fr'],
  filRouges: ['fr'],
  // Le hub /enquetes ne présente que dossiers, anatomies et Loupe : à ouvrir avec eux. Les
  // investigations, traduites, restent accessibles depuis les fiches acteurs.
  enquetes: ['fr'],
};

const PREFIXES: [string, Section][] = [
  ['/brief', 'brief'],
  ['/claim-checks', 'rayonx'],
  ['/veille', 'veille'],
  ['/loupe', 'loupe'],
  ['/anatomies', 'anatomies'],
  ['/dossiers', 'dossiers'],
  ['/fil-rouges', 'filRouges'],
  ['/enquetes', 'enquetes'],
];

export function sectionDisponible(section: Section, lang: Locale): boolean {
  return LANGUES[section].includes(lang);
}

/** La section d'une adresse interne (sans préfixe de langue), ou null. */
export function sectionDuChemin(href: string): Section | null {
  const chemin = href.split(/[?#]/)[0];
  for (const [prefixe, section] of PREFIXES) {
    if (chemin === prefixe || chemin.startsWith(`${prefixe}/`)) return section;
  }
  return null;
}

/** Un lien vers `href` a-t-il sa place dans une page en `lang` ? */
export function lienDisponible(href: string, lang: Locale): boolean {
  const s = sectionDuChemin(href);
  return !s || sectionDisponible(s, lang);
}
